import React from "react";
import { Route } from "react-router-dom";
import { UserRoleEnum } from "@/types/role.type";
import type { RouteCtx } from "../routeContext";
import { PlaceholderPage } from "../shell";
import {
  SiteAdminDashboard,
  UserManagement,
  SubjectsManagement,
  VisitDataEntry,
  DataCompletenessDashboard,
} from "../lazyPages";

/** siteAdminRoutes — order preserved for React Router first-match. */
export function siteAdminRoutes(ctx: RouteCtx): React.ReactNode {
  const { userRole, onLogout } = ctx;

  if (userRole !== UserRoleEnum.SITE_ADMIN) {
    return null;
  }

  return (
    <>
      <Route
        path="/site-admin/dashboard"
        element={<SiteAdminDashboard onLogout={onLogout} userRole={userRole} />}
      />
      <Route
        path="/site-admin/overview"
        element={<PlaceholderPage title="Site Overview" />}
      />
      <Route path="/site-admin/users" element={<UserManagement />} />
      <Route
        path="/site-admin/documents"
        element={<PlaceholderPage title="Documents" />}
      />
      <Route
        path="/site-admin/edc/subjects"
        element={<SubjectsManagement userRole={userRole} />}
      />
      <Route
        path="/site-admin/edc/visit-data-entry"
        element={<VisitDataEntry userRole={userRole} />}
      />
      <Route
        path="/site-admin/edc/data-completeness"
        element={<DataCompletenessDashboard userRole={userRole} />}
      />
      <Route path="/my-site" element={<PlaceholderPage title="My Site" />} />
      <Route
        path="/assigned-studies"
        element={<PlaceholderPage title="Assigned Studies" />}
      />
      <Route path="/staff" element={<PlaceholderPage title="Staff" />} />
    </>
  );
}
